// inlineMarkdown — tiny inline formatter for module body text.
// Supports **bold** and *italic* only. Block-level structure (paragraphs,
// callouts, scenes) is the block kit's job; this just handles emphasis.
import React from 'react';

// **bold** is matched before *italic* so the inner asterisks of a bold run
// are never seen as italics.
const INLINE_RE = /\*\*([^*]+)\*\*|\*([^*]+)\*/g;

export const formatInline = (text) => {
  if (typeof text !== 'string' || !text) return text;
  const parts = [];
  let cursor = 0;
  let match;
  let key = 0;
  INLINE_RE.lastIndex = 0;
  while ((match = INLINE_RE.exec(text)) !== null) {
    if (match.index > cursor) parts.push(text.slice(cursor, match.index));
    if (match[1] !== undefined) {
      parts.push(<strong key={`b-${key++}`} className="font-semibold text-white">{match[1]}</strong>);
    } else if (match[2] !== undefined) {
      parts.push(<em key={`i-${key++}`} className="italic text-slate-100">{match[2]}</em>);
    }
    cursor = match.index + match[0].length;
  }
  if (cursor < text.length) parts.push(text.slice(cursor));
  return parts.length === 0 ? text : parts;
};

export const FormattedText = ({ children, as: Tag = 'span', className }) => (
  <Tag className={className}>{formatInline(children)}</Tag>
);
